import { render, staticRenderFns } from "./ChatEditorPC.vue?vue&type=template&id=2bfc880d&scoped=true"
import script from "./ChatEditorPC.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatEditorPC.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ChatEditorPC.vue?vue&type=style&index=0&id=2bfc880d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfc880d",
  null
  
)

export default component.exports